export default {
  sm: `
  Global Platform for 
  Successful Overseas Service    
  `,
  md: `
  Global Platform for Successful 
  Overseas Service    
  `,
  xxl: `
  Global Platform 
  for Successful
  Overseas Service    
  `,
};
